import { render, staticRenderFns } from "./approve-details.vue?vue&type=template&id=2c4cd91d"
import script from "./approve-details.vue?vue&type=script&lang=ts"
export * from "./approve-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports